export const NAME_SPACE = 'dash_board_cash_income'
export const SELECTION_1 = 'selection-1'
export const SELECTION_2 = 'selection-2'
export const SELECTION_3 = 'selection-3'
export const SELECTION_4 = 'selection-4'
export const SELECTION_5 = 'selection-5'
